// import {store1} from '../store/index'

var DataStore = require('../store');
var store = DataStore.default

// const fetchPOST =  () =>{
//     return 'store.state.url.URL_APP'
// }

const fetchPOST = () => {
  return store.state.kamio
}

const getKab = (wilayah) => {
  fetch(store.state.url.URL_DATAMASTER_KAB_KOTA + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      wilayah: wilayah
    })
  })
    .then(res => res.json())
    .then(res_data => {
      console.log(res_data)
      store.state.listKabKota = res_data
    });
}


async function FETCH_GET (url){
  return new Promise(resolve =>{
    fetch(url, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      }
    })
      .then(res => res.json())
      .then(res_data => {
        // console.log(res_data)
        resolve(res_data)
      });
  })
}


async function FETCH_POST (url, body){
  return new Promise(resolve =>{
    fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body: JSON.stringify(body)
    })
      .then(res => res.json())
      .then(res_data => {
        // console.log(res_data)
        resolve(res_data)
      });
  })
}





module.exports = {
  fetchPOST: fetchPOST,
  getKab : getKab,
  FETCH_GET: FETCH_GET,
  FETCH_POST : FETCH_POST,


}